import { useEffect, useState } from "react";
import BlogCard from "./BlogCard";
import axios from "axios";
import BlogSkeleton from "./blogSkeleton";


const BlogGridCardSection = () => {

  const [blogs, setBlogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)


  const fetchBlogs = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/blog/get-all-blogs`,
        // { withCredentials: true }
      )

      // console.log(res.data.data)

      if (res.data.success) {
        setBlogs(res.data.data)
      }
    } catch (error) {
      console.log(`Error fetching blogs: ${error}`)
      setError('Failed to load blogs.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchBlogs()
  }, [])



  if (error) {
    return (
      <div className="pb-10 familjen-font">
        <div className="min-h-[50vh] flex items-center justify-center px-4">
          <div className="max-w-md w-full text-center animate-fade-in">
            <div className="mx-auto w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 animate-bounce-gentle">
              <div className="relative">
                <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">Oops! Something Went Wrong</h2>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 animate-pulse-soft">
              <p className="text-red-700 text-sm font-medium">
                {error || "We're having trouble loading this content. This might be temporary."}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                🔄 Try Again
              </button>
            </div>
            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-blue-800 text-sm">
                <strong>Need help?</strong> Contact support at{" "}
                <a href="mailto:support@example.com" className="underline hover:text-blue-600">
                  support@example.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <section className="md:px-10 px-6 py-10">
      <div className=" grid lg:grid-cols-3 grid-cols-1 gap-10">
        {loading ? Array(6).fill('').map((_, index) => <BlogSkeleton key={index} />) : blogs.map((blog, index) => (
          <BlogCard key={index} blog={blog} />
        ))}
      </div>
    </section>
  )
}

export default BlogGridCardSection;